import React, { useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormCheck } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { organizationApi } from "../../../../../../../services/Api/Organization/organizationApi";
import { SubscriptionsApi } from "../../../../../../../services/Api/Subscription/subscriptionTypes";
import { LoanApi } from "../../../../../../../services/Api/types";
import SubscriptionsTableSimple from "./SubscriptionsTableSimple";

interface Props {
	loan: LoanApi;
	estimatedLoan: SubscriptionsApi;
	handleUpdate: (data: LoanApi) => void;
}

interface FormProps {
	checked: boolean;
}

const AcceptLoan = (props: Props) => {
	const { loan, estimatedLoan, handleUpdate } = props;
	const [loading, setLoading] = useState(false);
	const { addSuccessFlash, addFlash } = useFlash();
	const { t } = useTranslation();
	const form = useForm<FormProps>({
		defaultValues: {
			checked: false,
		},
	});
	const {
		register,
		clearErrors,
		formState: { errors },
		getValues,
		setError,
	} = form;

	const onAccept = async () => {
		if (!getValues().checked) {
			setError(
				"checked",
				{
					message: undefined,
					types: {
						must_be_checked: undefined,
					},
				},
				{ shouldFocus: true }
			);
			addFlash({
				type: "danger",
				msg: "must_accept_terms",
			});
			return;
		}
		setLoading(true);
		try {
			const resp = await organizationApi.acceptLoan(loan.id);
			addSuccessFlash(t("common.flash.completed", { ns: "lib" }));
			handleUpdate(resp);
		} catch (e) {
			handleError.alert(e, addFlash);
		}
		setLoading(false);
	};

	const renderAcceptLabel = () => {
		return (
			<span>
				{t("modules.loan.field.accept.title")}
				<a href="https://www.gopos.pl/tos">{t("modules.loan.field.statute.title")}</a>,
				<a href="https://www.gopos.pl/privacy-policy">{t("modules.loan.field.privacy_policy.title")}</a>
				{t("modules.loan.field.receive_information.title")}
			</span>
		);
	};

	return (
		<Form>
			{loan.acceptation_status === "OPEN" && (
				<>
					{" "}
					<Alert variant={"warning"}>{t("modules.loan.field.loan_not_accepted.title")}</Alert>
				</>
			)}
			{loan.status === "OPEN" && loan.acceptation_status !== "OPEN" && (
				<>
					{" "}
					<Alert variant={"warning"}>{t("modules.loan.field.loan_not_signed.title")}</Alert>
				</>
			)}
			{loan.status === "ACCEPTED" && (
				<Alert variant={"warning"}>{t("modules.loan.field.loan_waiting.title")}</Alert>
			)}
			<fieldset className={"form-group"}>
				<SubscriptionsTableSimple estimatedLoan={estimatedLoan} />
			</fieldset>
			{loan.acceptation_status === "OPEN" && (
				<>
					<div className={"mb-4"}>{t("modules.loan.field.acceptation_status_information.title")}</div>
					<FormCheck
						className={"mb-3"}
						onClick={() => clearErrors()}
						register={register}
						type={"switch"}
						label={renderAcceptLabel()}
						name={"checked"}
						errors={errors}
					/>
					<Form.Group className="form-group">
						<ButtonLoading onClick={onAccept} loading={loading}>
							{t("modules.loan.action.loan.title")}
						</ButtonLoading>
					</Form.Group>
				</>
			)}
		</Form>
	);
};
export default AcceptLoan;
